<script lang="ts">
  export let icon: string;
</script>

<i class="icon" style="--icon: '{icon}'"></i>

<style>
  .icon {
    &::before {
      content: var(--icon);
      font-family: "Font Awesome 6 Free";
      font-style: normal;
    }
  }
</style>
